import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const TablewithSumFooter = ({
  columns,
  columnNames,
  data,
  showProceedButton = false,
  buttonName = 'Proceed',
  rowNameKey = 'rowname', // Default key for row name
  valueKey = 1, // Default key for value
  onRowClick = () => {},
  onButtonClick = () => {},

}) => {
  let qty = 0, val = 0;
  //console.log(rowNameKey);
  //console.log(valueKey);
  const showQty = columns.some((col) => col.toLowerCase().includes('itemquantity'));
  const showVal = columns.some((col) => col.toLowerCase().includes('itemvalue'));

  if (showQty || showVal) {
    data.forEach((row) => {
      columns.forEach((column) => {
        const value = parseFloat(row[column]);
        if (!isNaN(value)) {
          if (showQty && column.toLowerCase().includes('itemquantity')) qty += value;
          if (showVal && column.toLowerCase().includes('itemvalue')) val += value;
        }
      });
    });
  }

  return (
    <div className="row p-4">
      <div className="container" style={{ boxShadow: '5px 5px 15px rgba(0,0,0,0.2)', borderRadius: '10px' }}>
        <table className="table table-bordered table-hover" role="table">
          <thead>
            <tr className="table-dark">
              {columnNames.map((name, index) => (
                <th key={index} scope="col" className="cardBackGround">
                  {name}
                </th>
              ))}
              {showProceedButton && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => onRowClick(row[rowNameKey])}
                style={{ cursor: 'pointer' }}
              >
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    style={
                      column.toLowerCase().includes('pending days')
                        ? { textAlign: 'center' }
                        : {}
                    }
                  >
                    {column.toLowerCase().includes('date')
                      ? dayjs(row[column]).format('DD-MMM-YYYY')
                      : row[column]}
                  </td>
                ))}
              

              {showProceedButton && (
  <td>
    <button
      className={`btn ${row[rowNameKey] === valueKey ? "btn-danger" : "btn-primary"}`}
      disabled={row[rowNameKey] === valueKey}
      onClick={(e) => {
        e.stopPropagation();
        onButtonClick(row); // Pass the `row` object directly
      }}
    >
      {buttonName}
    </button>
  </td>
)}



              </tr>
            ))}
          </tbody>
          <tfoot>
            {(showQty || showVal) && (
              <tr>
                <td colSpan={columns.length + (showProceedButton ? 1 : 0)} style={{ textAlign: 'center' }}>
                  <strong>
                    {showQty && showVal
                      ? `Qty: ${qty.toFixed(2)}, Val: ${val.toFixed(2)}`
                      : showQty
                      ? `Qty: ${qty.toFixed(2)}`
                      : `Val: ${val.toFixed(2)}`}
                  </strong>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
    </div>
  );
};

TablewithSumFooter.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  showProceedButton: PropTypes.bool,
  buttonName: PropTypes.string,
  //rowNameKey: PropTypes.string.isRequired,
  //valueKey: PropTypes.string.isRequired,
  onRowClick: PropTypes.func,
  onButtonClick: PropTypes.func,
};

export default TablewithSumFooter;
